import { cn } from "@/lib/utils";
import { type FC } from "react";
import { type ProgramStructure2Data } from "./_schema";

// Title Section Component
export const TitleSection: FC<{ parsedData: ProgramStructure2Data }> = ({ parsedData }) => (
    <div className={cn(
        "flex flex-col mb-[24px]",
        "sm:mb-[28px]",
        "lg:mb-[36px]"
    )}>
        <p
            className={cn(
                "font-semibold leading-normal",
                "text-[24px]",
                "sm:text-[28px]",
                "md:text-[30px]",
                "lg:text-[30px]",
                "xl:text-[30px]"
            )}
            style={{
                color: parsedData.title_1_color,
                fontFamily: "var(--font-google-sans)"
            }}
        >
            {parsedData.title_1}
        </p>
        <p
            className={cn(
                "font-bold leading-[1.2] bg-clip-text text-transparent",
                "text-[40px] tracking-[1.2px]",
                "sm:text-[44px] sm:tracking-[1.32px]",
                "md:text-[54px] md:tracking-[1.62px]",
                "lg:text-[64px] lg:tracking-[1.92px]",
                "xl:text-[64px] xl:tracking-[1.92px]"
            )}
            style={{
                backgroundImage: parsedData.title_2_gradient_start_color && parsedData.title_2_gradient_end_color ?
                    `linear-gradient(to right, ${parsedData.title_2_gradient_start_color}, ${parsedData.title_2_gradient_end_color})` :
                    undefined,
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                fontFamily: "var(--font-merriweather)"
            }}
        >
            {parsedData.title_2}
        </p>
    </div>
);
